import { EventBus } from '../EventBus.js'
import moment from 'moment'

export default {
  methods: {
    changeLocale () {
      const locale = this.$route.query.lang
      if (locale && locale === 'ru') {
        this.setLocale('en')
      } else {
        this.setLocale('ru')
      }
    },
    setLocale (locale) {
      this.$i18n.locale = locale
      moment.locale(locale)
      this.$router.replace({ query: { lang: locale } })
      EventBus.$emit('locale-changed', locale)
    },
    isLocaleSupported (locale) {
      return locale && (locale === 'ru' || locale === 'en')
    }
  }
}
